import { RECEIPT_FETCH_REQUEST, RECEIPT_FETCH_SUCCESS, RECEIPT_FETCH_FAILURE } from './types';
import baseUrl from '../url'

const fetchReceiptRequest = () => {
    return {
        type: RECEIPT_FETCH_REQUEST
    }
}

const fetchReceiptSuccess = data => {
    return {
        type: RECEIPT_FETCH_SUCCESS,
        payload: data,
    }
}

const fetchReceiptFailure = error => {
    return {
        type: RECEIPT_FETCH_FAILURE,
        payload: error,
    }
}


export const getReceipt = slug => {
    return (dispatch) => {
        dispatch(fetchReceiptRequest());
        const token = localStorage.getItem('token');
        fetch(`${baseUrl}/receipts/${slug}`, {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            })
            .then(response => response.json())
            .then((response) => {
                dispatch(fetchReceiptSuccess(response));
            })
            .catch((error) => {
                dispatch(fetchReceiptFailure(error.message));
            })
    }
}